export default __webpack_public_path__ + "static/media/step3.8740bb03.svg";